// extracted by mini-css-extract-plugin
module.exports = {"Container":"ModalScreen_Container__2Hy-E","Background":"ModalScreen_Background__1Q_nz","Screen":"ModalScreen_Screen__seXD1","Content":"ModalScreen_Content__1NVat"};